import React from 'react';
import '../styles/groups-quick-actions.css';

const GroupsQuickActions = ({
  onBrowseGroups,
  onJoinGroup,
  onCreateGroup,
  discoveryOpen
}) => {
  return (
    <div className="groups-quick-actions">
      <button
        className={`quick-action-btn ${discoveryOpen ? 'active' : ''}`}
        onClick={onBrowseGroups}
        title="Browse and discover public groups"
      >
        <span className="action-icon">🔍</span>
        <span className="action-label">Browse</span>
      </button>

      <button
        className="quick-action-btn"
        onClick={onJoinGroup}
        title="Enter a group code to join"
      >
        <span className="action-icon">🚪</span>
        <span className="action-label">Join</span>
      </button>

      <button
        className="quick-action-btn primary"
        onClick={onCreateGroup}
        title="Create a new investment group"
      >
        <span className="action-icon">✨</span>
        <span className="action-label">Create</span>
      </button>
    </div>
  );
};

export default GroupsQuickActions;
